import { render, staticRenderFns } from "./AdminImport.vue?vue&type=template&id=595b6989&"
import script from "./AdminImport.vue?vue&type=script&lang=js&"
export * from "./AdminImport.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports